import qs from "qs";
import { api } from "shared/api";
import { API_ROUTES, defaultOptions } from "shared/api/consts";
import { GetTransactionBonusDTO } from "./models";

export const GetTransactionBonusApi = async (dto: GetTransactionBonusDTO) => {
  const { data } = await api.post(
    API_ROUTES.TRANSACTION_BONUS,
    qs.stringify({ ...defaultOptions(), ...dto })
  );

  return data;
};
